function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body, Container, Heading } from '../../atoms';
import ReactConfigContext from '../../ReactConfigContext';
export default function BigTitleSection(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'simple' : _param_variant, title = param.title, image = param.image, children = param.children, className = param.className;
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    return /*#__PURE__*/ React.createElement(Container, {
        name: BigTitleSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h1",
        variant: "h1",
        className: twMerge('max-w-md', variant === 'columns' && 'max-w-md mx-auto text-center')
    }, title), variant === 'simple' && /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max mt-7 gap-6 sm:grid-cols-[5fr_95fr] md:mt-5 md:grid-cols-[35fr_65fr]"
    }, !!image && /*#__PURE__*/ React.createElement("div", {
        className: "hidden items-center justify-center w-full h-full md:flex"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        className: twMerge('rounded-xl w-full h-auto max-w-[10rem] max-h-[10rem] object-cover object-center', image.className)
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "my-auto max-w-[36.25rem] sm:col-start-2"
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "md",
        className: "prose"
    }, children))), variant === 'columns' && /*#__PURE__*/ React.createElement("div", {
        className: "mt-7"
    }, !!image && /*#__PURE__*/ React.createElement("div", {
        className: "mb-6 flex justify-center"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        className: twMerge('rounded-xl max-w-xs', image.className)
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-md grid gap-7 grid-cols-1 md:grid-cols-2"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        variant: "md",
        className: "prose"
    }, Array.isArray(children) ? children[0] : children)), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        variant: "md",
        className: "prose"
    }, Array.isArray(children) ? children[1] : null)))));
}

//# sourceMappingURL=BigTitleSection.js.map